export const diccionary = {
    digitalBranch: {
       slakSelfie: {
            method: "POST",
            url: `${process.env.REACT_APP_URL_BRANCHDIGITAL}/sendSlack/wrongSelfie`,
       },
       saveINEFront: {
            method: "POST",
            url: `${process.env.REACT_APP_URL_BRANCHDIGITAL}/doSaveNumpyRedisByUuid`,
        }
    },
    digitalOnboarding: {
        consultFiles : {
            method : "GET",
            url:   `${process.env.REACT_APP_URL_ONBOARDINGDIGITAL}/consult/files`,
        },
        exceptions: {
            method : "POST",
            url:     `${process.env.REACT_APP_URL_ONBOARDINGDIGITAL}/process/exception/saved`,
        }
    },
    messages: {
        otpService: {
            method: "GET",
            url: `${process.env.REACT_APP_URL_WALLET}/twilioCode`,
        }
    },
    generalFunctions : {
        compareFaceNumpy: {
            method: "POST",
            url:    `${process.env.REACT_APP_URL_GENERALFUNCTIONS}/face/comparaNumpy`
        }
    }
};